import { setHardLogoutHandler } from '@/shared/api';
import { clearTokens, useSessionStore } from '@/shared/lib/auth';

/**
 * Install the non-React side effect that the HTTP client calls when a
 * reactive refresh fails. We can't `useNavigate` here (we're outside the
 * router tree), so we rely on the router's `AuthedLayout` to see the
 * session flip to `anonymous` and redirect to `/login`.
 */
export function installHardLogout(): void {
  setHardLogoutHandler(() => {
    clearTokens();
    useSessionStore.getState().clear();
  });
}
